import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import InfoCard from "../InfoCard";
import SafeHtml from "../../../../../../../../../components/SafeHtml";

import styles from "../../../styles";

const ExtraTexts = ({classes, extra_texts}) => (
  <>
    {extra_texts.map((textConfig, idx) => (
      <React.Fragment key={idx}>
        {textConfig.type === 'card' ? (
          <InfoCard isNewDesign cardType={textConfig.cardType}>
            <SafeHtml html={textConfig.text} />
          </InfoCard>
        ) : (
          <div className={classes.stepHelpText}>
            <SafeHtml html={textConfig.text} />
          </div>
        )}
      </React.Fragment>
    ))}
  </>
);

export default withStyles(styles)(ExtraTexts);